import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { Button, Input } from '../../components/ui';

export default function LoginPage() {
  const { login }  = useAuth();
  const navigate   = useNavigate();
  const [form, setForm]       = useState({ email: '', password: '' });
  const [error, setError]     = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(''); setLoading(true);
    try {
      await login(form.email, form.password);
      navigate('/');
    } catch (err) {
      setError(err.response?.data?.error || 'Login failed. Check credentials.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh', background: 'var(--bg-base)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      position: 'relative', overflow: 'hidden',
    }}>
      {/* Ambient glows */}
      <div style={{ position: 'absolute', top: -200, right: -200, width: 500, height: 500, borderRadius: '50%', background: 'radial-gradient(circle, rgba(232,164,58,0.06) 0%, transparent 70%)', pointerEvents: 'none' }} />
      <div style={{ position: 'absolute', bottom: -150, left: -150, width: 400, height: 400, borderRadius: '50%', background: 'radial-gradient(circle, rgba(78,156,245,0.04) 0%, transparent 70%)', pointerEvents: 'none' }} />

      <div style={{ width: 380, position: 'relative' }} className="fade-in">
        {/* Logo block */}
        <div style={{ textAlign: 'center', marginBottom: 36 }}>
          <div style={{ marginBottom: 16, display: 'flex', justifyContent: 'center' }}>
            <img
              src="/logos/logo-dark.png"
              alt="MilleHills"
              style={{ height: 56, width: 'auto', objectFit: 'contain' }}
              onError={e => {
                e.target.style.display = 'none';
                e.target.nextSibling.style.display = 'inline-flex';
              }}
            />
            {/* Fallback amber M box */}
            <div style={{
              display: 'none',
              alignItems: 'center', justifyContent: 'center',
              width: 52, height: 52, background: 'var(--accent)', borderRadius: 12,
              fontFamily: 'var(--font-display)', fontWeight: 800, fontSize: 24,
              color: '#0d0f12', boxShadow: 'var(--shadow-accent)',
            }}>M</div>
          </div>
          <h1 style={{ fontFamily: 'var(--font-display)', fontSize: 24, fontWeight: 700, color: 'var(--text-primary)', marginBottom: 6 }}>MilleHills Admin</h1>
          <p style={{ fontSize: 13, color: 'var(--text-muted)' }}>Ecosystem Console · Gisenyi, Rwanda</p>
        </div>

        {/* Form card */}
        <div style={{
          background: 'var(--bg-surface)', border: '1px solid var(--border)',
          borderRadius: 'var(--radius-lg)', padding: '32px',
          boxShadow: 'var(--shadow-md)',
        }}>
          <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: 18 }}>
            <Input label="Email Address" type="email" placeholder="admin@millehills.com"
              value={form.email} onChange={e => setForm(f => ({ ...f, email: e.target.value }))} required />
            <Input label="Password" type="password" placeholder="••••••••"
              value={form.password} onChange={e => setForm(f => ({ ...f, password: e.target.value }))} required />
            {error && (
              <div style={{
                background: 'var(--red-muted)', border: '1px solid var(--red)',
                borderRadius: 'var(--radius-sm)', padding: '10px 14px',
                fontSize: 13, color: 'var(--red)',
              }}>{error}</div>
            )}
            <Button type="submit" loading={loading} style={{ width: '100%', justifyContent: 'center', padding: '11px' }}>
              Sign In
            </Button>
          </form>
          <div style={{ marginTop: 20, paddingTop: 20, borderTop: '1px solid var(--border)', fontSize: 11, color: 'var(--text-muted)', textAlign: 'center', lineHeight: 1.8 }}>
            Founder-Led · Constitution-Protected · Capital-Flexible
          </div>
        </div>
      </div>
    </div>
  );
}